export default class App {
    constructor(config, appFactory) {
        this.config = config;
        this.appFactory = appFactory;

        // Sentry for us folks.
        this.sentry = appFactory.masterConfig.ENVIRONMENT.SENTRY.client;

        // AppName (Passed to the APIs and checkout script)
        this.appName = this.constructor.name;

        // Validate apps implementation.
        this.validateComponentImplementation(this);

        // Apply overrides / extension
        this.applyOverrides();
    }

    handleError(error) {
        debugger;
        this.sentry.captureException(error);
        console.error('Critical Error:', error);
    }

    validateComponentImplementation(component) {
        const requiredFunctions = ['init', 'isAppAllowedToRun', 'loadApp', 'postLoad', 'preLoad', 'overrideHook'];
        for (const funcName of requiredFunctions) {
            if (typeof component[funcName] !== 'function') {
                throw new Error(`App implementation is not valid. The function "${funcName}" is missing.`);
            }
        }
    }

    overrideMethod(name, fn) {
        this.overrides[name] = fn;
        this[name] = fn;
    }

    restoreMethod(name) {
        if (name in this.overrides) {
            this[name] = this.overrides[name];
            delete this.overrides[name];
        }
    }

    applyOverrides() {
        // Check if overrides exist for appFactory
        if (window.__PRIME_AI__.override[this.constructor.name]) {
            const appFactoryOverrides = window.__PRIME_AI__.override[this.constructor.name];
            for (const methodName in appFactoryOverrides) {
                if (appFactoryOverrides.hasOwnProperty(methodName)) {
                    this.overrideMethod(methodName, appFactoryOverrides[methodName]);
                }
            }
        }
    }
}
